













































import { namespace } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';
import { CART } from '@/store/types';
import { ProductAttributeInfo, ProductAttributeType } from '@eurogast/hub-client-typescript';
import { ProductUtil } from '@/services/ProductUtil';
import { LinkUtil } from '@/services/LinkUtil';
import { Cart, CartItem } from '@/services/cart/model/cart';

const cart = namespace(CART);

@Component({})
export default class PreOrderSection extends Vue {
  @cart.State('cart')
  public cart: Cart;

  private preOrderOpen = true;

  get preOrderItems() {
    return this.cart.items.filter((it: CartItem) => it.product.attributes.some(
      (attr: ProductAttributeInfo) => attr.key === ProductAttributeType.Bestellartikel
    ));
  }

  public togglePreOrderOpen() {
    this.preOrderOpen = !this.preOrderOpen;
  }

  public getAmountBySku(sku: string) {
    return ProductUtil.getAmountBySku(this.cart.items, sku);
  }

  public getBaseAmountBySku(sku: string) {
    return ProductUtil.getBaseAmountBySku(this.cart.items, sku);
  }

  public getStoragePriceBySku(sku: string) {
    return ProductUtil.getStoragePriceBySku(this.cart.items, sku);
  }

  public getSumBySku(sku: string) {
    return ProductUtil.getSumBySku(this.cart.items, sku);
  }

  public findImageUrl(item: CartItem): string {
    return LinkUtil.getProductImageUrl(item.product);
  }
}
